import { mapValues } from 'lodash';
/**
 * Version 43 migrations: adding missing syles for agenda and sessions widget
 */
export default function v43(website) {
  return {
    ...website,
    eventVersion: 43,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Agenda' && !layoutItem.config.style.speakerTitle) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            display: {
              ...layoutItem.config.display,
              speakers: true
            },
            style: {
              ...layoutItem.config.style,
              sessionSpeaker: {
                speakerCard: {
                  styleMapping: 'custom',
                  background: {
                    image: null,
                    color: 'accent',
                    borderRadius: 10
                  },
                  border: {
                    color: 'text',
                    thickness: 0,
                    borderStyle: 'solid'
                  },
                  spacing: {
                    padding: {
                      paddingBottom: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10
                    }
                  }
                },
                speakerProfileImage: {
                  styleMapping: 'custom',
                  text: {
                    textAlign: 'center',
                    fontFamily: 'primary',
                    color: 'text'
                  },
                  background: {
                    borderRadius: 100,
                    color: 'secondary'
                  },
                  border: {
                    color: 'text',
                    thickness: 1,
                    borderStyle: 'solid'
                  }
                },
                speakerName: {
                  styleMapping: 'text1'
                },
                speakerTitle: {
                  styleMapping: 'text2'
                },
                speakerCompany: {
                  styleMapping: 'text2'
                }
              },
              speakerModalName: {
                styleMapping: 'text1'
              },
              speakerModalDesignation: {
                styleMapping: 'text2'
              },
              speakerModalWebsites: {
                styleMapping: 'link'
              },
              speakerModalWebsitesTitle: {
                styleMapping: 'text2',
                customSettings: {
                  spacing: {
                    padding: {
                      paddingBottom: 15
                    }
                  }
                }
              },
              speakerModalTitle: {
                styleMapping: 'text2'
              },
              speakerModalCompany: {
                styleMapping: 'text2'
              },
              speakerModalBiography: {
                styleMapping: 'body1',
                customSettings: {
                  spacing: {
                    padding: {
                      paddingTop: 30
                    }
                  }
                }
              },
              speakerContactIcons: {
                styleMapping: 'custom',
                text: {
                  color: 'text'
                }
              }
            }
          }
        };
      }
      if (layoutItem.widgetType === 'Sessions' && !layoutItem.config.style.speakerTitle) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            display: {
              ...layoutItem.config.display,
              speakers: true
            },
            style: {
              ...layoutItem.config.style,
              sessionSpeaker: {
                speakerCard: {
                  styleMapping: 'custom',
                  background: {
                    image: null,
                    color: 'primary',
                    borderRadius: 10
                  },
                  border: {
                    color: 'text',
                    thickness: 0,
                    borderStyle: 'solid'
                  },
                  spacing: {
                    padding: {
                      paddingBottom: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10
                    }
                  }
                },
                speakerProfileImage: {
                  styleMapping: 'custom',
                  text: {
                    textAlign: 'center',
                    fontFamily: 'primary',
                    color: 'text'
                  },
                  background: {
                    borderRadius: 100,
                    color: 'secondary'
                  },
                  border: {
                    color: 'text',
                    thickness: 1,
                    borderStyle: 'solid'
                  }
                },
                speakerName: {
                  styleMapping: 'text1'
                },
                speakerTitle: {
                  styleMapping: 'text2'
                },
                speakerCompany: {
                  styleMapping: 'text2'
                }
              },
              speakerModalName: {
                styleMapping: 'text1'
              },
              speakerModalDesignation: {
                styleMapping: 'text2'
              },
              speakerModalWebsites: {
                styleMapping: 'link'
              },
              speakerModalWebsitesTitle: {
                styleMapping: 'text2',
                customSettings: {
                  spacing: {
                    padding: {
                      paddingBottom: 15
                    }
                  }
                }
              },
              speakerModalTitle: {
                styleMapping: 'text2'
              },
              speakerModalCompany: {
                styleMapping: 'text2'
              },
              speakerModalBiography: {
                styleMapping: 'body1',
                customSettings: {
                  spacing: {
                    padding: {
                      paddingTop: 30
                    }
                  }
                }
              },
              speakerContactIcons: {
                styleMapping: 'custom',
                text: {
                  color: 'text'
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
